// Copyright © 2019-2026 Focal Systems. All rights reserved.

export function AnswerText({ text, streaming }: { text: string; streaming: boolean }) {
  if (!text && !streaming) return null;
  return (
    <p className="mb-2 whitespace-pre-wrap text-sm leading-relaxed">
      {text}
      {streaming && (
        <span
          aria-hidden
          className="ml-0.5 inline-block h-3.5 w-1.5 animate-pulse rounded-[1px] bg-primary align-[-2px]"
        />
      )}
    </p>
  );
}
